export const palette = [
  "#0f766e", // teal
  "#f59e0b", // amber
  "#be123c", // crimson

  "#2563eb", // blue
  "#7c3aed", // violet
  "#16a34a", // green
  "#ea580c", // orange
  "#0891b2", // cyan
  "#9333ea", // purple
  "#65a30d", // lime
  "#db2777", // rose
  "#4f46e5", // indigo
];

export function getTicketTypeColour(index) {
  return palette[index % palette.length];
}

export function getTone(tone) {
  return {
    red: "[--tone:#ef4444]",
    green: "[--tone:#22c55e]",
    amber: "[--tone:#f59e0b]",
    grey: "[--tone:#EEEEEE]",
  }[tone] ?? "[--tone:#EEEEEE]";
}